import React, { Component } from 'react'
import * as moment from 'moment'
import { connect } from 'react-redux'
import axios from 'axios'
import Swal from 'sweetalert2'
const meatTitle = [
  'Pollo',
  'Ternera',
  'Pezcado',
  'Pavo',
  'Cerdo',
  'Mariscos',
  'Cordero',
  'Ninguna',
]
const allergiesTitle = [
  'Soya',
  'Lácteos',
  'Huevos',
  'Nueces',
  'gluten',
  'Legumbres',
  'Ninguna',
]
const badhabitsTitle = [
  'No dormir lo suficiente',
  'comer muy tarde',
  'Mucha sal en las comidas',
  'Mucho dulce y bollería',
  'Tomar gaseosas',
  'Ninguno',
]

let isLangchainRequestInProgress = false

class ButtonPlanComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      paymentDate: localStorage.getItem('paymentDate')
        ? moment(localStorage.getItem('paymentDate'))
        : null,
    }
    this.sentData = false
  }
  actividadFisicaCase(value) {
    switch (value) {
      case 'S':
        return 'Sedentario (Trabajo de oficina)'
      case 'EL':
        return 'ejercicio leve (1 a 2 días por semana)'
      case 'EM':
        return 'ejercicio moderado (3 a 5 días por semana)'
      case 'ED':
        return 'ejercicio duro (6 a 7 días por semana)'
      case 'A':
        return 'Atleta (2 veces al día)'
      default:
        return 'No definido'
    }
  }
  setObjetive(obj) {
    switch (obj) {
      case 1:
        return 'Aumentar masa muscular'
      case 2:
        return 'Mantenimiento'
      case 3:
        return 'Perder grasa corporal'
      default:
        return ''
    }
  }

  setBmiTipo(bmi) {
    if (bmi < 18.5) {
      return 'Bajo peso'
    }
    if (bmi >= 18.5 && bmi <= 24.9) {
      return 'Peso normal'
    }
    if (bmi >= 25 && bmi <= 29.9) {
      return 'Sobrepeso'
    }
    if (bmi >= 30) {
      return 'Obesidad'
    }
  }
  getAlimentationTypeDesc(type) {
    const options = [
      {
        value: 'omnivora',
        title: 'Omnívora 🥦🥩',
        desc: 'Comes de todo: carne, pescado, huevos, lácteos, frutas, verduras, cereales, legumbres.',
      },
      {
        value: 'pescetariana',
        title: 'Pescetariana 🐟🥦',
        desc: 'No comes carne, pero sí pescado, mariscos, huevos, lácteos, frutas, verduras, cereales y legumbres.',
      },
      {
        value: 'vegetariana',
        title: 'Vegetariana 🥦',
        desc: 'No comes carne ni pescado, pero sí huevos y/o lácteos.',
      },
      {
        value: 'vegana',
        title: 'Vegana 🌱',
        desc: 'Solo alimentos de origen vegetal (sin carne, pescado, huevos, lácteos ni miel).',
      },
    ]
    const element = options.find((option) => option.value === type.type)
    return element
  }
  setDietStyle(style) {
    const options = [
      {
        value: 1,
        title: 'Muy baja en carbohidratos (Keto / Cetogénica)',
      },
      {
        value: 2,
        title: 'Baja en carbohidratos (Low Carb)',
      },
      {
        value: 3,
        title: 'Moderada en carbohidratos (Balanceada)',
      },
    ]
    const element = options.find((option) => option.value === style)
    return element ? element.title : ''
  }

  async sendData() {
    if (this.sentData || isLangchainRequestInProgress || !this.props.email || !this.props.name) return
    this.sentData = true
    isLangchainRequestInProgress = true
    const data = {
      edad: this.props.edad,
      peso: `${this.props.peso} ${
        this.props.type_measure === 0 ? 'kg' : 'lbs'
      }`,
      altura: `${this.props.altura} ${
        this.props.type_measure === 0 ? 'cm' : 'in'
      }`,
      name: this.props.name,
      email: this.props.email,
      sexo: this.props.sexo,
      actividad_fisica: this.actividadFisicaCase(this.props.actividad_fisica),
      carnes: this.props.carnes
        .map((item, index) => (item === true ? meatTitle[index] : false))
        .filter((item) => item !== false),
      alergias: this.props.alergias
        .map((item, index) => (item === true ? allergiesTitle[index] : false))
        .filter((item) => item !== false),
      maloshabitos: this.props.maloshabitos
        .map((item, index) => (item === true ? badhabitsTitle[index] : false))
        .filter((item) => item !== false),
      objetivo: this.setObjetive(this.props.objetivo),
      calorias_nivel: this.props.calorias_nivel,
      calorias_objetivo:
        this.props.objetivo === 1
          ? this.props.calorias_objetivo + this.props.calorias_editor
          : this.props.calorias_objetivo - this.props.calorias_editor,
      bmi: this.props.bmi,
      bmi_interpretation: this.setBmiTipo(this.props.bmi),
      peso_ideal_kg: this.props.peso_ideal_kg,
      mpm_superior: this.props.mpm_superior,
      mpm_inferior: this.props.mpm_inferior,
      proteinasgramos: this.props.proteinas_dia_g,
      grasasgramos: this.props.grasa_dia_g,
      carbohidratosgramos: this.props.carbohidratos_dia_g,
      dietStyle: this.setDietStyle(this.props.dietStyle),
      cantidadComidas: this.props.cantidadComidas,
      tipoalimentacion:
        this.getAlimentationTypeDesc(this.props.tipoalimentacion)?.value || '',
      vegetarianOptions: {
        huevos: this.props.tipoalimentacion?.huevos || false,
        lacteos: this.props.tipoalimentacion?.lacteos || false,
      },
    }
    // Remove double slash if REACT_APP_API_URL ends with one
    const baseUrl = process.env.REACT_APP_API_URL.endsWith('/')
      ? process.env.REACT_APP_API_URL.slice(0, -1)
      : process.env.REACT_APP_API_URL

    const url = `${baseUrl}/api/langchain`

    try {
      const response = await axios({
        url: url,
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      })
      if (response.status === 200) {
        Swal.fire({
          title: '<span style="color: #aadc82">Excelente!</span>',
          html: `<p> Estamos generando tu plan de alimentación 100% personalizado; en las próximas horas estará llegando a tu correo electrónico.</p>
        <p>Si en las próximas horas aún no ha llegado, puedes volver aquí o ponerte en contacto con nosotros.</p>
        <p>Gracias por confiar en Fullmusculo</p>`,
          icon: 'success',
          theme: 'material-ui',
          confirmButtonColor: '#014bd5',
        })
      }
    } catch (error) {
      this.sentData = false
      isLangchainRequestInProgress = false
      console.error('Error sending data to langchain:', error)
      Swal.fire({
        title: 'Error',
        text: 'Hubo un problema al procesar tu solicitud. Por favor intenta de nuevo.',
        icon: 'error',
      })
    }

  }

  async changeTag() {
    if (this.props.contactId) {
      const url = `https://services.leadconnectorhq.com/contacts/${this.props.contactId}/tags`
      var body = JSON.stringify({
        tags: ['Calculadora de Calorías', 'Plan adquirido'],
      })
      const response = await axios({
        url: url,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${process.env.REACT_APP_HIGLEVEL_TOKEN}`,
          version: '2021-07-28',
        },
        data: body,
      })
    }
  }
  render() {
    return (
      <>
        {!this.state.paymentDate ||
        moment().diff(this.state.paymentDate, 'hours') >= 24 ? (
          <a
            onClick={() => localStorage.removeItem('paymentDate')}
            href={`${process.env.REACT_APP_STRIPE_URL}?locked_prefilled_email=${this.props.email}&name=${this.props.name}`}
            className="nutrition-button"
          >
            🔥 QUIERO MI PLAN PERSONALIZADO
          </a>
        ) : (
          <button onClick={() => this.sendData()} className="nutrition-button">
            🔥 QUIERO MI PLAN PERSONALIZADO
          </button>
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  sexo: state.sexo,
  actividad_fisica: state.actividad_fisica,
  carnes: state.carnes,
  alergias: state.alergias,
  maloshabitos: state.maloshabitos,
  objetivo: state.objetivo,
  edad: state.edad,
  altura: state.altura,
  peso: state.peso,
  email: state.email,
  name: state.name,
  type_measure: state.type_measure,
  bmr: state.bmr,
  calorias_nivel: state.calorias_nivel,
  bmi: state.bmi,
  peso_ideal_kg: state.peso_ideal_kg,
  mpm_superior: state.mpm_superior,
  mpm_inferior: state.mpm_inferior,
  calorias_objetivo: state.calorias_objetivo,
  calorias_editor: state.calorias_editor,
  proteinas_dia_g: state.proteinas_dia_g,
  grasa_dia_g: state.grasa_dia_g,
  carbohidratos_dia_g: state.carbohidratos_dia_g,
  tipoalimentacion: state.tipoalimentacion,
  dietStyle: state.dietStyle,
  cantidadComidas: state.cantidadComidas,
  contactId: state.contactId,
})
const mapDispatchToProps = (dispatch) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(ButtonPlanComponent)
